import { useCallback, useState } from "react";
import { LoginRequest } from "../../models/LoginRquest";
import { LoginResponse } from "../../models/LoginResponse";
import {
  bookAppointment,
  doLogout,
  getAllPatients,
  getBookedAllAppointments,
  login,
  register,
} from "./apis";
import { APIResponse } from "../../models/LogOutModel";
import { RegisterRequest } from "../../models/RegisterRequest";
import { AppointmentBody } from "../../models/AppointmentBody";
import { BookedAppointmentDetails } from "../../models/BookedAppointmentDetails";
import { IPatientList } from "../../models/PatientListModel";

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<APIResponse | null>(null);

  const loginUser = useCallback(async (body: LoginRequest) => {
    setLoading(true);
    setError(null);
    try {
      const response = await login(body);
      setData(response);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const loginState = { loading, error, data };

  return [loginState, loginUser] as const;
};

export const useLogOut = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<APIResponse | null>(null);

  const logoutUser = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await doLogout();
      setData(response);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const logoutState = { loading, error, data };

  return [logoutState, logoutUser] as const;
};

export const useRegister = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<APIResponse | null>(null);

  const loginUser = useCallback(async (body: RegisterRequest) => {
    setLoading(true);
    setError(null);
    try {
      const response = await register(body);
      setData(response);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const loginState = { loading, error, data };

  return [loginState, loginUser] as const;
};

export const useBookAppointment = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<APIResponse | null>(null);

  const loginUser = useCallback(async (body: AppointmentBody) => {
    setLoading(true);
    setError(null);
    try {
      const response = await bookAppointment(body);
      setData(response);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const loginState = { loading, error, data };

  return [loginState, loginUser] as const;
};

export const useFetchBookedAppointment = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<BookedAppointmentDetails[] | []>([]);

  const loginUser = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getBookedAllAppointments();
      setData(response);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const loginState = { loading, error, data };

  return [loginState, loginUser] as const;
};

export const useFetchAllPatients = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<IPatientList[] | []>([]);

  const loginUser = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getAllPatients();
      setData(response);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const loginState = { loading, error, data };

  return [loginState, loginUser] as const;
};
